import { CashLocationType } from "@repo/database";
import { CashLocationSchema } from "@repo/validators";
import { useTranslation } from "react-i18next";

import type { CashLocation } from "~/providers/cash-location-provider";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  useForm,
} from "../ui/form";
import { Input } from "../ui/input";
import { MultiSelect } from "../ui/multi-select";

export default function CashLocationForm({
  onClose,
  cashLocation,
}: {
  onClose: () => void;
  cashLocation?: CashLocation;
}) {
  const { t, i18n } = useTranslation("common");
  const form = useForm({
    schema: CashLocationSchema(i18n),
    defaultValues: {
      name: cashLocation?.name ?? "",
      type: cashLocation?.type ?? CashLocationType.drawer,
    },
  });
  return (
    <Form {...form}>
      <form className="grid grid-cols-2 gap-2">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>{t("CashLocation.name")}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          disabled={cashLocation?.isDefault === true}
          control={form.control}
          name="type"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>{t("CashLocation.type")}</FormLabel>
              <FormControl>
                <MultiSelect
                  disabled={cashLocation?.isDefault === true}
                  maxSelect={1}
                  placeholder="Select a type..."
                  onValueChange={(value) => {
                    field.onChange(value[0]);
                    void form.trigger();
                  }}
                  options={Object.values(CashLocationType)
                    .sort()
                    .map((type) => ({
                      label: type,
                      value: type,
                    }))}
                  defaultValue={[field.value]}
                  value={[field.value]}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
